export { PaperConnectionBannerComponent } from './paper-connection-banner.component';
